module.exports = {
    title: 'vuTick',

    // apiUrl: 'http://35.247.243.23:8080',
    // apiUrl: 'http://localhost:8080',
    // apiUrl: 'http://192.168.0.106:8080',
    // smartDrone
    // apiUrl: 'http://smartdrone.ddns.net:8080',
    // apiUrl: 'http://smartdrone.uy:8080',
    //
    // In production the app is served from the same domain as the API
    // (Caddy reverse-proxies /api to the Spring Boot jar), so requests
    // should be same-origin/relative instead of pointing at a hardcoded
    // IP. That also avoids mixed-content issues once the site is on HTTPS.
    // For local dev (npm run serve), it still points at the real backend.
    apiUrl: process.env.NODE_ENV === 'production' ? '' : 'http://193.123.104.197:8080',
    /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
    showSettings: true,

    /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
    fixedHeader: true,

    /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
    sidebarLogo: true,

    /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
    errorLog: 'production'
};
